export default __webpack_public_path__ + "static/media/history_1950_02.59aec39a.png";